
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/keeping-cool",
      function () {
        return require("private-next-pages/stories/keeping-cool.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/keeping-cool"])
      });
    }
  